import React, { Component } from "react";
import { NavItem, Nav, NavDropdown, MenuItem } from "react-bootstrap";
import cookie from 'react-cookies';
class HeaderLinks extends Component {
   
  logout() {
    cookie.remove('token_key', { path: '/' });
    window.open('/login', "_self");
  }
  render() {
    let adminName = '';

    if (
      this.props.adminListQuery &&
      this.props.adminListQuery.loading == false &&
      this.props.adminListQuery.adminList != undefined
    ) {
      adminName = this.props.adminListQuery.adminList.admin[0].admin_username;
    }
    return (
      <div>
        <Nav pullRight>
          {/* <NavItem eventKey={1} href="/dashboard">
            <i className="fa fa-dashboard" />
            <p className="hidden-lg hidden-md">Dashboard</p>
          </NavItem> */}
          {/* <NavDropdown
            eventKey={2}
            title={notification}
            noCaret
            id="basic-nav-dropdown"
          >
          </NavDropdown> */}
          {/* <NavItem eventKey={3} href="#">
            <i className="fa fa-search" />
            <p className="hidden-lg hidden-md">Search</p>
          </NavItem> */}
          <NavDropdown
            title={adminName}
            style={{padding: '3px 0'}}
          >
            <MenuItem onClick={() => this.logout()} >ออกจากระบบ</MenuItem>
          </NavDropdown>
        </Nav>
      </div>
    );
  }
}

export default HeaderLinks;
